<template>
  <div :class="{footer: true}" @click="$emit('open-chat')">
    <div :class="{'footer-container': true}">
      <div class="footer-wrapper">
        <div class="message-counter" v-if="newMessages > 0"><b>{{newMessages}}</b></div>
        <div class="room-avatar" :style="{'background-image': backgroundUrl}"></div>
        <div class="name-wrapper">
          <div class="name-text">{{name}}</div>
        </div>
      </div>
      <div v-if="isActive" style="max-height: 30px;
    display: flex; margin-left: 4px">
        <bell-ring class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: #23282c" ></bell-ring>
      </div>
    </div>
  </div>
</template>

<script>
import BellRing from 'vue-material-design-icons/BellRingOutline.vue'
export default {
  name: "TaskMessagingFooter",
  components: {
    BellRing
  },
  props: {
    newMessages: {
      type: Number,
      default: () => 0
    },
    name: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    backgroundUrl() {
      return this.name === 'Aufgaben' ? "url(/ic_task_int.png)": (this.name === "Auftraggeber" ? "url(/ic_task.png)" : "url(/share.png)");
    },
  }
}
</script>

<style scoped>
.footer {
  height: 50px;
  cursor: pointer;
  transition: all .2s;
  z-index: 100
}

.footer-container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 0 8px;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  background-color: white;
  border: 1px solid #d3cfcf;
}

.footer-container:hover {
  background-color: #d3cfcf;
  transition: background-color .2s;
}

.footer .active {
  background-color: #4DBD74;
}

.footer-wrapper {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  height: 100%;
}

.message-counter {
  background-color: #ff0000;
  height: 25px;
  width: 25px;
  min-height: 25px;
  min-width: 25px;
  margin-right: 3px;
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  color: white;
}
.name-wrapper {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 17px;
  font-weight: 500;
  line-height: 22px;
}

.room-avatar {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 35px;
  width: 35px;
  min-height: 35px;
  min-width: 35px;
  margin-right: 6px;
}
</style>
